var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectBtnIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.1,
    height: 18,
    viewBox: "0 0 18.1 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2886",
    "data-name": "Group 2886",
    transform: "translate(-864 -624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2885",
    "data-name": "Group 2885"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_840",
    "data-name": "Rectangle 840",
    width: 18,
    height: 18,
    transform: "translate(864 624)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "connect-01",
    transform: "translate(864 624.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 6.1,
    cy: 6.1,
    r: 6.1,
    transform: "translate(2.9 3.5)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(5.9 0.5)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(0 10.4)",
    fill: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 3.1,
    cy: 3.1,
    r: 3.1,
    transform: "translate(11.9 10.8)",
    fill: "#0d0d0d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectBtnIcon);
export default __webpack_public_path__ + "static/media/connect-btn-icon.40ea0ed4ad60db6d8a4bda8d2d9b0efa.svg";
export { ForwardRef as ReactComponent };